import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { ATTACHMENT_API } from "./apiRoutes";

const mutateAddAttachmentWithEntity = async ({
  entityType,
  entityId,
  data,
}: {
  entityType: string;
  entityId: string;
  data: any;
}) => {
  return await axiosAuth.post(
    `${ATTACHMENT_API}/entity/${entityType}/${entityId}`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useAddAttachmentWithEntityMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      entityType: string;
      entityId: string;
      data: any;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddAttachmentWithEntity,
    ...queryParams,
  });

export default useAddAttachmentWithEntityMutation;
